@use "styles" as *;
@use "sass:map";

$block: me-image;

.#{$block} {
  display: inline-block;
  position: relative;

  img {
    max-width: 100%;
    height: auto;
    margin: 0 auto;
    display: block;
  }

  &--responsive {
    display: block;
  }

  &--responsive, &--responsive img {
    width: 100%;
  }

  @each $theme, $theme-options in $image-themes {
    &--#{$theme}.#{$block}--highlighted {
      border: 1px solid map.get($theme-options, border-color);
    }
  }

  &--round {
    border-radius: $me-image-border-radius;
    overflow: hidden;
  }

  &--contain {
    background-color: $color-background-image;

    img {
      object-fit: contain;
    }
  }

  &--cover {
    img {
      object-fit: cover;
    }
  }

  &--blur {
    position: relative;
    overflow: hidden;
    display: block;
    background-color: $color-background-image;

    img {
      z-index: 2;
      position: relative;
      display: block;
      object-fit: contain;
      width: 100%;
    }

    .#{$block}__background-blur {
      z-index: 1;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      transform: scale(1.1);
      filter: blur($me-image-blur);
      opacity: .4;
      object-fit: cover;
    }
  }

  &--grayscale {
    filter: grayscale(1);
  }

  &__overlay {
    position: absolute;
    display: flex;
    flex-direction: column;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 3;

    &--with-gradient {
      background: $me-image-gradient;
    }
  }

  &__overlay > * {
    padding: space(0.5, 2);
  }

  &--has-overlay-slot &__overlay > * {
    padding: space(2, 5);
  }

  &__overlay &__author {
    padding-top: space(0.5);
    padding-bottom: space(0.5);
  }

  &__author {
    align-self: flex-end;
    box-sizing: content-box;
    background: $color-background-translucent;


    &-label {
      color: $color-text;
      @include lineClamp($me-image-author-max-lines);
    }
  }

  @each $name, $size in only($font-sizes, $me-image-font-sizes...) {
    &.#{$block}--#{$name} {
      font-size: $size;

      .#{$block}__author {
        max-height: calc(
          ($line-height-base * $me-image-author-max-lines) * $size
        );
      }
    }
  }
}
